import urls from '../../constants/urls';

import { ORGANISATIONS_API_CLIENT } from '../../middleware/multiClientHandler';
export const LOADING_ORGANISATION = 'organisation/LOADING_ORGANISATION';
export const ORGANISATION_LOAD_FAILED = 'organisation/ORGANISATION_LOAD_FAILED';
export const ORGANISATION_LOAD_SUCCESS =
  'organisation/ORGANISATION_LOAD_SUCCESS';

const initialState = {
  organisation: null,
  failedLoading: false,
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ORGANISATION:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case ORGANISATION_LOAD_SUCCESS:
      return {
        ...state,
        organisation: action.payload.data.data,
        isLoading: false,
      };

    case ORGANISATION_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };
    default:
      return state;
  }
};

export const loadOrganisation = organisationId => dispatch => {
  return dispatch({
    types: [
      LOADING_ORGANISATION,
      ORGANISATION_LOAD_SUCCESS,
      ORGANISATION_LOAD_FAILED,
    ],
    payload: {
      customClient: ORGANISATIONS_API_CLIENT,
      request: {
        url: urls.organisationsApi.organisations.show(organisationId),
      },
    },
  });
};
